import { TYPES } from 'action-types/exception-management'

interface IAction {
	readonly type: string
	readonly exceptions: any
	readonly logs: any
	readonly notifications: any
	readonly errors: string
	readonly file: any
	readonly reprocess: any
	readonly reprocessLogs: any
	readonly update: any
	readonly toggleReprocess: any
}
export interface IEMState {
	readonly isFetchDataLoading: boolean
	readonly isFetchDataError: boolean
	readonly exceptions: any
	readonly logs: any
	readonly notifications: any
	readonly reprocessLogs: any
	readonly errors: string
	readonly reprocess: any
	readonly update: any
	readonly file: any
	readonly toggleReprocess: any
}
export interface INotification {
	notificationId: string
	itemType: string
	referenceId: string
	status: string
	createdDate: string
	resolvedDate?: string
	message: string
	documentNumber: string
	agedInSeconds: string
	aging: string
}

export const defaultState: IEMState = {
	isFetchDataLoading: false,
	isFetchDataError: false,
	errors: '',
	reprocess: null,
	update: null,
	file: null,
	exceptions: {
		pageNumber: 0,
		pageSize: 0,
		result: [],
		totalCount: 0,
	},
	logs: {
		pageNumber: 0,
		pageSize: 0,
		result: [],
		totalCount: 0,
	},
	notifications: {
		pageNumber: 0,
		pageSize: 0,
		result: [],
		totalCount: 0,
	},
	reprocessLogs: {
		pageNumber: 0,
		pageSize: 0,
		result: [],
		totalCount: 0,
	},
	toggleReprocess: {
		pageNumber: 0,
		pageSize: 0,
		result: [],
		totalCount: 0,
	},
}

export const reducer = (
	state: IEMState = defaultState,
	action: IAction
): IEMState => {
	switch (action.type) {
		case TYPES.FETCH_EXCEPTIONS.PENDING:
			return {
				...state,
				isFetchDataError: false,
				isFetchDataLoading: true,
				exceptions: defaultState.exceptions,
				errors: '',
			}
		case TYPES.FETCH_EXCEPTIONS.FULFILLED:
			return {
				...state,
				isFetchDataLoading: false,
				exceptions:
					action.exceptions &&
					action.exceptions.result
						? action.exceptions
						: defaultState.exceptions,
			}
		case TYPES.FETCH_EXCEPTIONS.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				isFetchDataLoading: false,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error during Exception Management request',
			}
		case TYPES.FETCH_EXCEPTIONS.RESET_ERROR:
			return {
				...state,
				isFetchDataError: true,
				isFetchDataLoading: false,
				errors: action.errors,
			}
		case TYPES.FETCH_LOGS.PENDING:
			return {
				...state,
				isFetchDataError: false,
				isFetchDataLoading: true,
				logs: defaultState.logs,
				errors: '',
			}
		case TYPES.FETCH_LOGS.FULFILLED:
			return {
				...state,
				isFetchDataLoading: false,
				logs:
					action.logs && action.logs.result
						? action.logs
						: defaultState.logs,
			}
		case TYPES.FETCH_LOGS.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				isFetchDataLoading: false,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error during Interface Logs request',
			}
		case TYPES.FETCH_LOGS.RESET_ERROR:
			return {
				...state,
				isFetchDataError: true,
				isFetchDataLoading: false,
				errors: action.errors,
			}
		case TYPES.REPROCESS.PENDING:
			return {
				...state,
				isFetchDataError: false,
				reprocess: null,
			}
		case TYPES.REPROCESS.FULFILLED:
			return {
				...state,
				reprocess: action.reprocess
					? action.reprocess
					: 'Reprocess ok',
			}
		case TYPES.REPROCESS.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error during Reprocess',
			}
		case TYPES.UPDATE_NOTIFICATIONS.PENDING:
			return {
				...state,
				isFetchDataError: false,
				update: null,
			}
		case TYPES.UPDATE_NOTIFICATIONS.FULFILLED:
			return {
				...state,
				update: action.update
					? action.update
					: 'Update ok',
			}
		case TYPES.UPDATE_NOTIFICATIONS.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error during Update',
			}
		case TYPES.FILE.PENDING:
			return {
				...state,
				isFetchDataError: false,
				file: '',
				errors: '',
			}
		case TYPES.FILE.FULFILLED:
			return {
				...state,
				file: action.file,
			}
		case TYPES.FILE.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error during file request',
			}
		case TYPES.FETCH_NOTIFICATIONS.PENDING:
		case TYPES.RESET_NOTIFICATIONS.FULFILLED:
			return {
				...state,
				isFetchDataError: false,
				notifications: defaultState.notifications,
				errors: '',
			}
		case TYPES.FETCH_NOTIFICATIONS.FULFILLED:
			return {
				...state,
				notifications:
					action.notifications &&
					action.notifications.result
						? action.notifications
						: defaultState.notifications,
			}
		case TYPES.FETCH_NOTIFICATIONS.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error during Interface Notifications request',
			}
		case TYPES.FETCH_REPROCESS.PENDING:
		case TYPES.RESET_REPROCESS.FULFILLED:
			return {
				...state,
				isFetchDataError: false,
				reprocessLogs: defaultState.reprocessLogs,
				errors: '',
			}
		case TYPES.FETCH_REPROCESS.FULFILLED:
			return {
				...state,
				reprocessLogs:
					action.reprocessLogs &&
					action.reprocessLogs.result
						? action.reprocessLogs
						: defaultState.reprocessLogs,
			}
		case TYPES.FETCH_REPROCESS.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error During Reprocess Logs Request',
			}
		case TYPES.TOGGLE_REPROCESS.PENDING:
			return {
				...state,
				isFetchDataLoading: true,
				toggleReprocess: defaultState.toggleReprocess,
				errors: '',
			}
		case TYPES.TOGGLE_REPROCESS.FULFILLED:
			return {
				...state,
				isFetchDataLoading: false,
				exceptions:
					action.toggleReprocess &&
					action.toggleReprocess.result
						? action.toggleReprocess
						: defaultState.toggleReprocess,
			}
		case TYPES.TOGGLE_REPROCESS.REJECTED:
			return {
				...state,
				isFetchDataError: true,
				errors:
					action.errors &&
					action.errors.length > 0
						? action.errors
						: 'Error During Reset Reprocess Request',
			}
		default:
			return state
	}
}
